<template>
  <div class="ActivityDiscount">
    <div class="bg"><img src="https://cms.dafang24.com/aliapp/20201030/1.png"><a href="javascript:;" class="getCoupon" @click="getActivityDiscount"></a></div>
    <div class="bg"><img src="https://cms.dafang24.com/aliapp/20201030/2.png"></div>
    <div class="bg"><img src="https://cms.dafang24.com/aliapp/20201030/3.png"></div>
    <div class="bg"><img src="https://cms.dafang24.com/aliapp/20201030/4.png"></div>
    <div class="bg"><img src="https://cms.dafang24.com/aliapp/20201030/5.png"></div>
    <div class="bg"><img src="https://cms.dafang24.com/aliapp/20201030/6.png"></div>
  </div>
</template>

<script>
import { orderSource } from "@/utils/env";
import { getConsumerCoupons, DrawCoupon } from "@/utils/api";
export default {
  name: "visitHubei",
  data() {
    return {
      couponList: [
        { OfferID: 364, name: "双十一-1天减50元。" },
        { OfferID: 366, name: "双十一-2天减100元。" },
        { OfferID: 367, name: "双十一-3天减150元。" },
        { OfferID: 368, name: "双十一-4天减200元。" },
        { OfferID: 369, name: "双十一-5天减250元。" },
        { OfferID: 370, name: "双十一-6天减300元。" },
        { OfferID: 371, name: "双十一-7天减350元。" }
      ],
    };
  },
  created() {},
  mounted() {},
  methods: {
    getActivityDiscount() {
      if (localStorage.getItem("token")) {
        let couponList = this.couponList;
        this.consumerCouponsFn(couponList);
      } else {
        this.flexible.showToast({
          content: "请先登陆/注册！",
          success: () => {
            this.goLogin();
          },
        });
      }
    },
    goLogin() {
      if (orderSource == 17) {
        window.webkit.messageHandlers.openPage.postMessage(
          JSON.stringify({ type: "app", url: "/LonginActivity" })
        );
      } else if (orderSource == 16) {
        dfpanda.openPage(
          JSON.stringify({ type: "app", url: "/app/LonginActivity" })
        );
      }
    },
    goHome() {
      if (orderSource == 17) {
        window.webkit.messageHandlers.goHome.postMessage();
      } else if (orderSource == 16) {
        dfpanda.goHome();
      }
    },
    async consumerCouponsFn(copList) {
      // 获取用户优惠券
      let res = await getConsumerCoupons();
      if (res.Code == 100) {
        let uCoupon = res.Data || [];
        if (uCoupon.length) {
          for (let i in uCoupon) {
            for (let j in copList) {
              if (uCoupon[i].OfferID == copList[j].OfferID) {
                copList.splice(j, 1);
              }
            }
          }
        }
        if (copList.length) {
          let lastRes = false;
          for (let item of copList) {
            let gRes = await this.getDrawCoupon(item.OfferID);
            if (gRes) {
              lastRes = gRes;
            }
          }
          if (lastRes) {
            this.flexible.showToast({
              duration: 1200,
              content: "领取成功！",
            });
          } else {
            this.flexible.showToast({ content: "领取失败，请重试" });
          }
        } else {
          this.flexible.showToast({
            duration: 1200,
            content: "领取成功！",
          });
          // this.flexible.showToast({
          //   duration:1200,
          //   content:'领取成功！去租车',
          //   success:()=>{
          //     this.goHome()
          //   }
          // })
        }
      } else if (res.Code == 17007) {
        this.goLogin();
      }
    },
    async getDrawCoupon(offerID) {
      let res = await DrawCoupon({
        data: {
          OfferID: offerID,
          orgID: 0,
        },
        isLoading: 1,
        loadContent: "获取优惠券...",
      });
      if (res.Code == 100) {
        return true;
      }
      return false;
    },
  },
};
</script>
<style lang="scss" scoped>
.ActivityDiscount {
  .bg {
    width: 100%;
    position: relative;
    .getCoupon {
      display: block;
      width: 90%;
      height:200px;
      position: absolute;
      left: 5%; bottom: 10px;
      /*background-color: rgba(0,0,0,.5);*/
    }
  }
  img { width: 100%; }
}
</style>
